/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { type Ref, type RefCallback, type MutableRefObject, useMemo } from 'react';

/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */
export function mergeRefs<T>(...refs: Ref<T>[]): RefCallback<T> {
	return (value: T | null) => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(value);
			} else if (ref != null) {
				// oxlint-disable-next-line typescript/consistent-type-assertions
				(ref as MutableRefObject<T | null>).current = value; // eslint-disable-line no-param-reassign
			}
		});
	};
}

export default function useMergeRefs<T>(...refs: readonly (Ref<T> | null)[]): RefCallback<T> {
	return useMemo(
		() => mergeRefs(...refs),

		// eslint-disable-next-line react-hooks/exhaustive-deps
		refs,
	);
}
